import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class LocalStorageService {

  private storage: Storage;
  private storageSub = new Subject<string>();


  constructor() {
    this.storage = window.localStorage;
  }

  set(key: string, value: any): boolean {

    if (value !== undefined && value !== null) {
      if (this.storage) {
        this.storage.setItem(key, JSON.stringify(value));
        this.storageSub.next(key)
        return true;
      }
      return false;
    }
    return false;
  }

  watchStorage() {
    return this.storageSub.asObservable();
  }

  get(key: string): any {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    try {
      return JSON.parse(raw);
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  remove(key: string): boolean {
    if (this.storage) {
      this.storage.removeItem(key);
      this.storageSub.next(key);
      return true;
    }
    return false;
  }

  clear(): boolean {
    if (this.storage) {
      this.storage.clear();
      return true;
    }
    return false;
  }
}
